import { getJson } from '../base';

export async function get(path: string): Promise<string> {
    const url = `/api/docs/${path}`;
    return getJson(url) as Promise<string>;
}